import React, { useEffect, useState } from "react";
import "./ProductDetailsPage.css";
import Breadcrumb_comp from "../Common-Component/Breadcrumb_comp/Breadcrumb_comp";
import ProductsImgComponent from "./ProductsImgComponent/ProductsImgComponent";
import ProductInfoComponent from "./ProductInfoComponent/ProductInfoComponent";
import ProductDescriptionTabsComponent from "./ProductDescriptionTabsComponent/ProductDescriptionTabsComponent";
import SimilarProducts from "./SimilarProducts/SimilarProducts";
import YouMightIntrested from "./YouMightIntrested/YouMightIntrested";
import { useParams } from "react-router-dom";
import { getProduct } from "../../features/products/productsSlice";
import { useDispatch, useSelector } from "react-redux";
import { decodeId } from "../../utils/common";
const ProductDetailsPage = () => {
  const { id } = useParams(); // encoded ID from URL
  const [productId, setProductId] = useState(null); // decoded ID

  useEffect(() => {
    if (id) {
      const decoded = decodeId(id);
      setProductId(decoded);
    }
  }, [id]);

  const product = useSelector((state) => state.product.product);
  const breadcrumbData = [
    { name: "Home", link: "/home" },
    { name: product?.name }, 
  ];


  const dispatch = useDispatch();
  
  useEffect(() => {
    if (productId) { // Ensure ID is valid before dispatching
      dispatch(getProduct(productId ));
    }
  }, [dispatch, productId]); // Runs when 'id' changes

 

  
  return (
    <section className="ProductDetailsPage">
      <div className="custom_container">
        <div className="breadcrump_main_div">
          <Breadcrumb_comp data={breadcrumbData} />
        </div>

        <div className="product_info_main_div_sec">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <ProductsImgComponent product={product} />
            </div>
            <div className="col-lg-6 col-md-6">
              <ProductInfoComponent product={product}/>
            </div>
          </div>
        </div>

        <div className="product_description_tabs_div">
          <ProductDescriptionTabsComponent product={product}/>
        </div>

        <div className="similar_products_div">
          <SimilarProducts product={product} />
        </div>

        <div className="you_might_intrested_div">
          <YouMightIntrested product={product}/>
        </div>
      </div>
    </section>
  );
};

export default ProductDetailsPage;
